import * as React from "react";
import styled from "styled-components";
import Dialog from "../../../mobile/components/Dialog";
import ModalClose from "../../../mobile/components/ModalClose";
const ReceemedModal = styled.div `
	z-index: 99999999;
	width: 19.6875rem;
	background: #fff;
	border-radius: 0.375rem;
	display: inline-block;
	white-space: normal;
`;
const Congratulation = styled.div `
	margin: 2.5rem 1.5rem 0 1.5rem;
	text-align: center;
	color: black;
	> img {
		width: 14.4375rem;
		height: 6.1875rem;
		margin-top: 0.9375rem;
	}
`;
const ExpiredTime = styled.div `
	color: #666;
	font-size: 0.75rem;
	text-align: center;
	margin: 0.75rem 1.5rem 0 1.5rem;
`;
const UseVoucher = styled.div `
	color: #333;
	font-size: 0.875rem;
	text-align: center;
	margin-top: 0.9375rem;
	margin: 0.9375rem 1.5rem 1.5rem 1.5rem;
`;
const Btn = styled.div `
	width: 16.6875rem;
	height: 2.25rem;
	background: linear-gradient(133deg, rgba(255, 114, 0, 1) 0%, rgba(255, 90, 0, 1) 100%);
	border-radius: 2px;
	text-align: center;
	margin: 0 auto;
	line-height: 2.25rem;
	margin-bottom: 1.5rem;
`;
export default class TipsModal extends React.Component {
    render() {
        const { data, isShow, closeModal, cbJump } = this.props;
        if (!data) {
            return null;
        }
        const { link, time, img } = data;
        return (React.createElement(Dialog, { show: isShow, isAutoFixedBody: true },
            React.createElement(ModalClose, { onClose: closeModal },
                React.createElement(ReceemedModal, null,
                    React.createElement(Congratulation, null,
                        "Congratulation! You have got",
                        React.createElement("img", { src: img })),
                    React.createElement(ExpiredTime, null,
                        "Expired Date: ",
                        time),
                    React.createElement(UseVoucher, null, "Use this voucher upon check out to enjoy great discounts!"),
                    link && (React.createElement(Btn, { onClick: () => {
                            closeModal();
                            if (cbJump) {
                                cbJump(link);
                            }
                        } }, "GO SHOPPING"))))));
    }
}
